<div class="container">
  <div class="page-content" (scroll)="onScroll()" #contentDiv>
    <app-left-bar [section]="'plan'"></app-left-bar>
    <div class="main-content">
      <!-- Header Section (inlined) -->
      <div class="plan-header">
        <div class="header-div">
          <h1 class="header-title">Build Your Plan</h1>
          <p class="description">
            Turn exploration into action. See how to communicate your skills to employers,
            how they align with your career goal, and get personalized
            recommendations to help you grow.
          </p>
        </div>
      </div>

      <!-- Sticky Steps Navigation -->
      <div class="steps-div">
        <div class="step-row" (click)="scrollToStep(1)" tabindex="0" role="button" (keydown.enter)="scrollToStep(1)" (keydown.space)="scrollToStep(1)">
          <img 
            [src]="`/assets/icons/build-plan/header-step-1${activeStep === 1 || !isPlanGenerated ? '-filled' : ''}.svg`" 
            alt="step-no" 
          />
          <p class="step-title" [class.step-title-active]="activeStep === 1 || !isPlanGenerated">
            Understand Your <br> Strengths
          </p>
        </div>
        <img src="/assets/icons/build-plan/step-arrow.svg" alt="arrow" class="step-arrow" />
        <div class="step-row" (click)="scrollToStep(2)" tabindex="0" role="button" (keydown.enter)="scrollToStep(2)" (keydown.space)="scrollToStep(2)">
          <img 
            [src]="`/assets/icons/build-plan/header-step-2${activeStep === 2 || !isPlanGenerated ? '-filled' : ''}.svg`" 
            alt="step-no" 
          />
          <p class="step-title" [class.step-title-active]="activeStep === 2 || !isPlanGenerated">Plan Your Path</p>
        </div>
        <img src="/assets/icons/build-plan/step-arrow.svg" alt="arrow" class="step-arrow" />
        <div class="step-row" (click)="scrollToStep(3)" tabindex="0" role="button" (keydown.enter)="scrollToStep(3)" (keydown.space)="scrollToStep(3)">
          <img 
            [src]="`/assets/icons/build-plan/header-step-3${activeStep === 3 || !isPlanGenerated ? '-filled' : ''}.svg`" 
            alt="step-no" 
          />
          <p class="step-title" [class.step-title-active]="activeStep === 3 || !isPlanGenerated">Take Action</p>
        </div>
      </div>

      @if (isPlanGenerated) {
        <!-- Skillprint, Assessments, and Resume Components -->
        <app-skillprint #skillprint (resumeUploaded)="onResumeUploaded()"></app-skillprint>

        <!-- Plan Your Path Component -->
        <app-plan-path #planPath (resumeUploaded)="onResumeUploaded()"></app-plan-path>

        <!-- Take Action Component -->
        <app-take-action #takeAction></app-take-action>
      } @else {
        <!-- Build Your Plan Locked State -->
        <app-generate-plan
          (planGenerateEmitter)="onClickPlanGenerate()"
        ></app-generate-plan>
      }
    </div>
  </div>
</div>